import Hidden from '@material-ui/core/Hidden';

import DrawerContent from '../DrawerContent/DrawerContent';
import { DrawerContainer, StyledDrawer, StyledSwipeableDrawer, StyledToolbar } from './styled';

/*
 * This components renders the drawer (sidebar).
 *
 * Two drawers are rendered, a fixed one for large screens, above 960px,
 * and a swipeable one for small screens, below 10 px.
 *
 * With the Hidden component of Material-UI, one of the two drawers is always hidden.
 */

interface Props {
    show: boolean;
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
}

const Drawer = (props: Props) => {
    const { show, isOpen, setIsOpen } = props;

    return (
        <DrawerContainer show={show}>
            <Hidden mdUp implementation='css'>
                {/* swipeable drawer, for small screens */}
                <StyledSwipeableDrawer
                    variant='temporary'
                    anchor={'left'}
                    open={isOpen}
                    onOpen={() => setIsOpen(true)}
                    onClose={() => setIsOpen(false)}
                    ModalProps={{
                        keepMounted: true,
                    }}
                    disableBackdropTransition
                >
                    <DrawerContent closeDrawer={() => setIsOpen(false)} />
                </StyledSwipeableDrawer>
            </Hidden>

            <Hidden smDown implementation='css'>
                {/* fixed drawer, for large screens */}
                <StyledDrawer variant='permanent'>
                    <StyledToolbar />
                    <DrawerContent closeDrawer={() => setIsOpen(false)} />
                </StyledDrawer>
            </Hidden>
        </DrawerContainer>
    );
};

export default Drawer;
